
import lodash from 'lodash';
// 获取地址中参数
export function GetQueryString(name, url) {
  let url1 = url ? url : window.location.search
  let arr = url1.split('?')[1].split('&')
  let parm
  arr.forEach((item) => {
    if (item.split('=')[0] == name) {
      parm = item.split('=')[1]
    }
  })
  return parm ? parm : ''
}
// 判断当前是否为微信环境
export function is_weixin() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') != -1) {
    return true
  } else {
    return false
  }
}

// 替换文案中的链接成可点击的a标签
export function changeHref(content) {
  if (!content) {
    return "";
  }
  let html = getSpan(content)
  let urlPattern =
    /(http:\/\/|https:\/\/|www\.|[a-zA-Z_0-9]?)[a-zA-Z_0-9\-@]+(\.\w[a-zA-Z_0-9\-:]+)+(\/[\(\)~#&\-=?\+\%/\.\w]+)?[a-zA-Z_0-9]/g;
  content = content.replace(urlPattern, function (match) {
    var href = match;
    if (match.indexOf("http") == -1) {
      href = "http://" + match;
    }
    return '<a target="_blank" href="' + href + '">' + match + "</a>";
  });
  let arrayTable = content.match(/<table[^>]*>([\s\S]*?)<\/table>/g);
  if(arrayTable && arrayTable.length > 0) {
    content = content.replace(arrayTable[0], '<table class="ai-table">' + html + '</table>');
  }
  return content;
}

export function getSpan(html) {
  let arraySpan = html.match(/<table[^>]*>([\s\S]*?)<\/table>/g);
  let results = [];
  if (arraySpan && arraySpan.length > 0) {
    results = arraySpan.map(item => {
      let array = item.match(/<table[^>]*>([\s\S]*?)<\/table>/);
      return lodash.get(array, '[1]', '');
    });
    return results[0];
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js